<template>
	<div :class="dialog==1?'':'app-container'">
		<el-table
			:data="formData"
			border
			fit
			:max-height="437"
			style="width: 100%"
		>
			<el-table-column align="center" label="操作" width="100">
				<template slot-scope="{ row }">
					<el-button
						size="mini"
						icon="el-icon-plus"
						circle
						@click="addRow(row)"
					/>
					<el-button
						size="mini"
						icon="el-icon-minus"
						type="danger"
						circle
						@click="removeRow(row)"
					/>
				</template>
			</el-table-column>

			<template v-for="(col, index) in cols">
				<el-table-column
					:key="index"
					:label="col.label"
					:width="col.width"
					:align="col.align"
					:min-width="col.min_width"
					:class-name="col.class"
				>
					<template slot-scope="{ row }">
						<template v-if="col.edit">
							<template v-if="col.type === 'customerEdit'">
								<el-autocomplete style="width:100%" v-model="row.cname" :fetch-suggestions="querySearchAsync"
								placeholder="输入客户" @select="changeAuto($event,row)">
								</el-autocomplete>
							</template>
							<template v-else-if="['payEdit','freeEdit','backEdit','otherBackEdit'].indexOf(col.type)>=0">
								<el-input v-model="row[col.prop]" :min="0" type="number" @input="$common.checkMoney($event,row,col.prop)"/>
							</template>
							<template v-else-if="col.type === 'dataEdit'">
								<el-date-picker style="width:100%" :editable="false" v-model="row.date" type="datetime"  format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" />
							</template>
							<template v-else-if="col.type === 'accountEdit'">
								<el-select style="width:100%" v-model="row.accountid">
									<el-option v-for="item in accountid" :key="item.id" :label="item.name+'('+item.account+')'" :value="item.id">
									</el-option>
								</el-select>
							</template>
							<template v-else-if="col.type === 'remarkEdit'">
								<el-input maxlength="50" v-model="row.remark" />
							</template>
						</template>
					</template>
				</el-table-column>
			</template>
		</el-table>
		<div class="rootbtn">
			<el-button type="primary" @click="save">确认</el-button>
			<el-button @click="cancel">取消</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			dialog: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				loading: true,
				customer: [],
				accountid: [],
				cols: [
					{
						prop: "cuid",
						label: "客户",
						edit:'customerEdit',
						type: "customerEdit",
						min_width: 220,
					},
					{
						prop: "pay",
						label: "收款金额(元)",
						edit:'payEdit',
						type: "payEdit",
						width: 130,
					},
					{
						prop: 'back',
						label: '退款金额(元)',
						show: true,
						edit: 'backEdit',
						type: 'backEdit',
						width: 130
					},
					{
						prop: "free",
						label: "免除金额(元)",
						edit:'freeEdit',
						type: "freeEdit",
						width: 130,
					},
					{
						prop: 'otherBack',
						label: '零星退货(元)',
						show: true,
						edit: 'otherBackEdit',
						type: 'otherBackEdit',
						width: 160
					},
					{
						prop: "date",
						label: "日期",
						edit:'dataEdit',
						type: "dataEdit",
						width: 200,
					},
					{
						prop: "accountid",
						label: "结算账号",
						edit:'accountEdit',
						type: "accountEdit",
						width: 160,
					},
					{
						prop: "remark",
						label: "备注",
						edit:'remarkEdit',
						type: "remarkEdit",
						min_width: 200,
						align: "center",
					},
				],
				maxCount:1,
				formData: [{
					id:0,
					cuid: 0,
					cname:'',
					pay: 0,
					free: 0,
					back:0,
					otherBack:0,
					date: '',
					accountid: '',
					remark: ''
				}],
				search: {
					page: 1,
					limit: 40,
					customer: '',
				},
				selectAcc:"",
			}
		},
		mounted() {
			this.getCompanyAccounts()
			this.formData[0].date = this.$common.format(new Date())
		},
		methods: {
			querySearchAsync(qs,cb){
				let result = [];
				let obj = {
					customer:qs,
					state:this.$global.customerState?this.$global.customerState:'',
				}
            	this.$api.customerlistCustomer(obj).then((res)=>{
					if(res.data.code==1){
						let data = res.data.data;
						data.forEach(e=>{
							let obj = {
								id:e.id,
								value:e.cname,
							}
							result.push(obj);
						})
						cb(result);
					}
            	})
			},
			changeAuto(e,row){
				row.cuid = e.id;
				row.cname = e.value;
       		},
			getCompanyAccounts() {
				this.$api.companygetCompanyAccount({}).then(res => {
					if(res.data.code==1){
						let data = res.data.data;
						this.accountid = data
						if(data.length>0){
							let index = 0;
							for(let i in data){
								if(data[i].isdefault==1){
									index = i;
									break;
								}
							}
							this.selectAcc = data[index].id;
							this.formData[index].accountid = this.selectAcc;
						}
					}
				}, () => {})
			},
			save() {
				for(let i in this.formData){
					let e = this.formData[i];
					if(e.cuid<1){
						this.$common.error("未选择客户");
						return;
					}
					if(e.pay<0||e.free<0){
						this.$common.error("金额不能为负");
						return;
					}
					if(e.pay<1&&e.free<1){
						this.$common.error("金额未填写");
						return;
					}
					if(!e.date){
						this.$common.error("未选择时间");
						return;
					}
					if(e.accountid<1){
						this.$common.error("未选择结算账号");
						return;
					}
					for(let j in this.accountid){
						let acc = this.accountid[j];
						if(acc.id==e.accountid){
							e.account =  acc.name+'('+acc.account+')';
							break;
						}
					}
					for(let j in this.customer){
						let cat = this.customer[j];
						if(cat.id==e.cuid){
							e.cname = cat.cname;
							break;
						}
					}
				}
				let obj = {
					data:JSON.stringify(this.formData),
				}
				this.$api.batchAddCustomerPayment(obj).then(res => {
					if(res.data.code==1){
						this.maxCount = 1;
						this.formData = [{
							id:0,
							cuid: '',
							cname:'',
							pay: 0,
							free: 0,
							back:0,
							otherBack:0,
							date: this.$common.format(new Date()),
							accountid: this.selectAcc,
							remark: ''
						}]
						if(this.$listeners['save']) {
							this.$emit("save", res);
						} else {
							this.$store.state.tagsView.visitedViews.splice(this.$store.state.tagsView.visitedViews.findIndex(item => item.path === this.$route.path), 1)
							this.$router.push("/finance/payment/list");
						}
						this.$notify({
							title: "新增收款",
							message: "添加收款成功",
							type: "success",
							duration: 1500,
						});
					}
					
				}, () => {})
			},
			cancel() {
				if(this.$listeners['cancel']) {
					// 如果提供执行
					this.$emit("cancel")
				} else {
					// 否侧执行其他
					this.$store.state.tagsView.visitedViews.splice(this.$store.state.tagsView.visitedViews.findIndex(item => item.path === this.$route.path), 1)
					this.$router.push(this.$store.state.tagsView.visitedViews[this.$store.state.tagsView.visitedViews.length - 1].path)
				}
			},
			addRow(row) {
				let index = this.getIndex(row);
				let obj = {
					id: this.maxCount,
					cuid: '',
					cname:'',
					pay: 0,
					free: 0,
					back:0,
					otherBack:0,
					date: this.$common.format(new Date()),
					accountid: this.selectAcc,
					remark: ''
				}
				if(index>=0){
					this.formData.splice(index+1, 0, obj);
				}else{
					this.formData.push(obj);
				}
				this.maxCount++;
			},
			removeRow(row){
				if(this.formData.length<=1){
					let obj = this.formData[0];
					if(obj!=null){
						obj.cuid="";
						obj.cname="";
						obj.pay=0;
						obj.free=0;
						obj.back=0;
						obj.otherBack=0;
						obj.remark="";
					}
					return;
				}
				let index = this.getIndex(row);
				if(index>=0){
					this.formData.splice(index, 1);
				}
			},
			getIndex(row){
				let id = row.id;
				for(let i=0;i<this.formData.length;i++){
					if(this.formData[i].id==id){
						return i;
					}
				}
				return -1;
			}
		}
	}
</script>
